var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.183 7.042C16.308 3.192 12.95 1.46 10 1.46H9.99c-2.941 0-6.308 1.725-7.183 5.575-.975 4.3 1.658 7.942 4.042 10.233A4.53 4.53 0 0 0 10 18.542a4.496 4.496 0 0 0 3.141-1.275c2.384-2.291 5.017-5.925 4.042-10.225ZM10 11.217a2.625 2.625 0 1 1-.001-5.249 2.625 2.625 0 0 1 0 5.25Z",
    fill: "#EEAD06"
  })));
};
export default SvgLocation;